export default __webpack_public_path__ + "static/media/illustration-recruit-5-w@3x.f71e2b03.webp";